module.exports = __webpack_public_path__ + "roboto-italic-webfont-927fdbf83b347742d39f0b00f3cfa99a.woff";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto/roboto-italic-webfont.woff
// module id = 853
// module chunks = 86